module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "cummins_banner_mobile.ad2f2e43.svg";